module.exports = __webpack_public_path__ + "img/logo_cota_white_mobile.42eef05e.svg";